export const getPythonIsoTimestamp = () => {
  const date = new Date();
  const pad = (number: number, length: number) => {
    return number.toString().padStart(length, "0");
  };

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1, 2);
  const day = pad(date.getUTCDate(), 2);
  const hours = pad(date.getUTCHours(), 2);
  const minutes = pad(date.getUTCMinutes(), 2);
  const seconds = pad(date.getUTCSeconds(), 2);
  const microseconds = pad(Math.floor(date.getUTCMilliseconds() * 1000), 6);

  const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${microseconds}+00:00`;

  return isoString;
};

/**
 * Converts a Date object to Python ISO format string
 * @param date - The Date object to convert
 * @returns Python ISO format string (YYYY-MM-DDTHH:mm:ss.microseconds+00:00)
 */
export const getPythonIsoStringDate = (date: Date): string => {
  const pad = (number: number, length: number) => {
    return number.toString().padStart(length, "0");
  };

  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1, 2);
  const day = pad(date.getUTCDate(), 2);
  const hours = pad(date.getUTCHours(), 2);
  const minutes = pad(date.getUTCMinutes(), 2);
  const seconds = pad(date.getUTCSeconds(), 2);
  const microseconds = pad(Math.floor(date.getUTCMilliseconds() * 1000), 6);

  const isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${microseconds}+00:00`;

  return isoString;
};
